<template>
	<div id="table-search" class="lg-13 md-12 sm-16">
		<div class="search-label">
			<Tooltip :text="searchContent.label" :message="searchContent.definition" :labelClasses="[]"></Tooltip>
		</div>
		<div class="search-input__medium-to-large lg-6 md-8 sm-16">
			<SearchInput
				:id="searchId"
				:label="searchContent.label"
				:labelHidden="true"
				v-model="$v.searchInput.$model"
				:placeholder="searchContent.placeholder"
				:vuelidateItem="$v.searchInput"
				:vuelidateRules="searchInputRules"
				validationFixedHeight="24px"
				@input="filterTableData"
			/>
		</div>
		<div class="search-input__small lg-6 md-8 sm-16">
			<SearchInput
				:id="searchIdSmall"
				:label="searchContent.label"
				:labelHidden="true"
				v-model="$v.searchInput.$model"
				:placeholder="searchContent.placeholderSmall"
				:vuelidateItem="$v.searchInput"
				:vuelidateRules="searchInputRules"
				validationFixedHeight="24px"
				@input="filterTableData"
			/>
		</div>
	</div>
</template>

<script>
import Tooltip from "@vg-faset/ui/src/components/tooltip/Tooltip";
import { validationMixin } from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
import { SearchInput } from "@vg-faset/ui/src/components/input";
import adobeLaunchService from "../services/adobeLaunchService.js";

export default {
	name: "TableSearch",
	components: {
		Tooltip,
		SearchInput
	},
	mixins: [validationMixin],
	props: {
		searchId: {
			type: String,
			required: true
		},
		tableData: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			searchInput: "",
			isTypingSearch: false,
			searchInputDelay: null,
			filterTerms: []
		};
	},
	validations: {
		searchInput: {
			noSpecialCharacters: helpers.regex("noSpecialCharacters", /^[ A-Za-z0-9.,&-]*$/)
		}
	},
	computed: {
		content() {
			return this.$store.state.content;
		},
		searchContent() {
			return this.content.search;
		},
		searchInputRules() {
			return {
				noSpecialCharacters: this.content.search.validationMessages.noSpecialCharacters
			};
		},
		showSearchError() {
			return this.searchInput.length > 0 && this.filteredTableData.length === 0;
		},
		searchIdSmall() {
			return this.searchId + "-small";
		}
	},
	methods: {
		rowContainsSearchTerms: function (row, filterTerms) {
			return filterTerms.some(function (filterText) {
				return (
					(filterText !== "" && row.name !== undefined ? row.name.toLowerCase().includes(filterText) : false) ||
					(filterText !== "" && row.ticker !== undefined ? row.ticker.toLowerCase().includes(filterText) : false)
				);
			});
		},
		getFilterTerms: function (termsToFilterOn) {
			let filteredTextArray = [];

			if (termsToFilterOn.includes(",")) {
				let splitTerms = termsToFilterOn.split(",");
				filteredTextArray = splitTerms.map((term) => term.trim());
			} else {
				filteredTextArray.push(termsToFilterOn);
			}
			return filteredTextArray;
		},
		filterRowData: function () {
			let filteredRows = [];

			this.isTypingSearch = true;
			this.filterTerms = this.getFilterTerms(this.$v.searchInput.$model.toLowerCase());
			for (const row of this.tableData) {
				if (this.rowContainsSearchTerms(row, this.filterTerms)) {
					filteredRows.push(row);
				}
			}

			return filteredRows;
		},
		filterTableData: function () {
			let filteredRows = [];
			if (!this.$v.searchInput.$invalid) {
				if (this.$v.searchInput.$model !== "") {
					filteredRows = this.filterRowData();
				} else {
					filteredRows = this.tableData;
				}
				this.filteredTableData = filteredRows;
				this.$emit("updateFilteredTableRows", filteredRows);
				this.$emit("updateSearchErrorState", this.showSearchError, this.searchInput);
			}
		}
	},
	watch: {
		isTypingSearch: function (isTyping) {
			if (isTyping === false && this.searchInput.length !== 0 && !this.$v.searchInput.$invalid) {
				adobeLaunchService.trackSearchConducted(this.searchInput);
			}
		},
		searchInput: function () {
			if (this.isTypingSearch) {
				clearTimeout(this.searchInputDelay);
				this.searchInputDelay = setTimeout(() => {
					this.isTypingSearch = false;
				}, 3000);
			}
		}
	}
};
</script>

<style lang="scss">
#table-search {
	.search-label {
		margin-bottom: 14px;
		font-size: 14px;
	}

	.input-text {
		padding-left: 40px;
		margin-bottom: 8px;
	}

	@include from-md {
		.search-input-wrapper {
			min-width: 366px;
		}
	}

	.search-input__medium-to-large {
		margin-bottom: 4px;
		min-width: 360px;

		.search-input-text {
			min-width: 366px;
		}

		@include to-bp(401px) {
			display: none;
		}
	}

	.search-input__small {
		margin-bottom: 4px;

		@include from-bp(401px) {
			display: none;
		}
	}
}
</style>
